import Sispat from "../../components/Sispat/Sispat";
import WorkerSkills from "../../components/WorkerSkills";

const SispatPage: React.FC = () => {
	return <Sispat/>
};

export default SispatPage;

